(function () {
  /* ── city pools ── */
  var CITIES_USD = [
    // Large
    ['New York','NY'],['Los Angeles','CA'],['Chicago','IL'],['Houston','TX'],
    ['Dallas','TX'],['San Diego','CA'],['San Francisco','CA'],['Seattle','WA'],
    ['Denver','CO'],['Atlanta','GA'],['Miami','FL'],['Boston','MA'],
    ['Austin','TX'],['Nashville','TN'],['Portland','OR'],['Phoenix','AZ'],
    ['Philadelphia','PA'],['Charlotte','NC'],['Minneapolis','MN'],
    // Mid / specific
    ['Scottsdale','AZ'],['Boca Raton','FL'],['Boulder','CO'],
    ['Santa Barbara','CA'],['Asheville','NC'],['Ann Arbor','MI'],
    ['Bend','OR'],['Sarasota','FL'],['Westport','CT'],['Greenwich','CT'],
    ['Lake Oswego','OR'],['Highland Park','IL'],['Edina','MN'],
    ['Park City','UT'],['Montecito','CA'],['Plano','TX'],['Frisco','TX'],
    ['The Woodlands','TX'],['Alpharetta','GA'],['Naples','FL'],
    ['Jupiter','FL'],['Wilmington','NC'],['Raleigh','NC'],['Bethesda','MD'],
    ['McLean','VA'],['Arlington','VA'],['Palo Alto','CA'],['Menlo Park','CA'],
    ['Laguna Beach','CA'],['Newport Beach','CA'],['Pasadena','CA'],
    ['Bellevue','WA'],['Kirkland','WA'],['Aspen','CO'],
    ['Carmel','CA'],['Sonoma','CA'],['Chapel Hill','NC'],
    ['Portsmouth','NH'],['Madison','WI'],['Richmond','VA'],
    ['Evanston','IL'],['Marin','CA'],['Vero Beach','FL'],
    ['Santa Monica','CA'],['Hoboken','NJ'],['Stamford','CT'],
    ['Chattanooga','TN'],['Bozeman','MT'],['Charlottesville','VA'],
    ['Tucson','AZ'],['Columbus','OH'],['Lexington','KY'],
    ['Fort Collins','CO'],['Iowa City','IA'],['Savannah','GA'],
    ['Birmingham','AL'],['Providence','RI'],['Burlington','VT'],
  ];

  var CITIES_AUD = [
    // Sydney / NSW: Eastern Suburbs
    ['Bondi','NSW'],['Bondi Beach','NSW'],['Bronte','NSW'],['Tamarama','NSW'],
    ['Clovelly','NSW'],['Coogee','NSW'],['Maroubra','NSW'],['Randwick','NSW'],
    ['Double Bay','NSW'],['Vaucluse','NSW'],['Bellevue Hill','NSW'],
    ['Rose Bay','NSW'],['Woollahra','NSW'],['Dover Heights','NSW'],
    ['Watsons Bay','NSW'],['Paddington','NSW'],['Darlinghurst','NSW'],
    ['Surry Hills','NSW'],['Potts Point','NSW'],['Elizabeth Bay','NSW'],
    // Sydney / NSW: Inner West & City
    ['Balmain','NSW'],['Birchgrove','NSW'],['Newtown','NSW'],['Glebe','NSW'],
    ['Pyrmont','NSW'],['Annandale','NSW'],['Leichhardt','NSW'],
    ['Drummoyne','NSW'],['Erskineville','NSW'],['Marrickville','NSW'],
    // Sydney / NSW: Lower & Upper North Shore
    ['Mosman','NSW'],['Cremorne','NSW'],['Neutral Bay','NSW'],
    ['Kirribilli','NSW'],['North Sydney','NSW'],['McMahons Point','NSW'],
    ['Northbridge','NSW'],['Castlecrag','NSW'],['Hunters Hill','NSW'],
    ['Lane Cove','NSW'],['Chatswood','NSW'],['Willoughby','NSW'],
    ['Lindfield','NSW'],['Killara','NSW'],['Pymble','NSW'],['Wahroonga','NSW'],
    // Sydney / NSW: Northern Beaches
    ['Manly','NSW'],['Freshwater','NSW'],['Dee Why','NSW'],['Narrabeen','NSW'],
    ['Mona Vale','NSW'],['Avalon Beach','NSW'],['Palm Beach','NSW'],
    // NSW: Sutherland Shire & Regional
    ['Cronulla','NSW'],['Byron Bay','NSW'],['Bangalow','NSW'],
    // Melbourne / VIC: Inner East
    ['South Yarra','VIC'],['Toorak','VIC'],['Armadale','VIC'],['Malvern','VIC'],
    ['Hawthorn','VIC'],['Kew','VIC'],['Camberwell','VIC'],['Canterbury','VIC'],
    ['Balwyn','VIC'],['Surrey Hills','VIC'],['Glen Iris','VIC'],['Prahran','VIC'],
    ['Windsor','VIC'],['Richmond','VIC'],
    // Melbourne / VIC: Inner North & City
    ['Fitzroy','VIC'],['Collingwood','VIC'],['Carlton','VIC'],
    ['Northcote','VIC'],['Fairfield','VIC'],['Ascot Vale','VIC'],
    ['Ivanhoe','VIC'],['Eltham','VIC'],
    // Melbourne / VIC: Bayside
    ['St Kilda','VIC'],['Elwood','VIC'],['Albert Park','VIC'],
    ['Middle Park','VIC'],['Port Melbourne','VIC'],['Brighton','VIC'],
    ['Hampton','VIC'],['Sandringham','VIC'],['Black Rock','VIC'],
    ['Caulfield','VIC'],['Elsternwick','VIC'],['Williamstown','VIC'],
    // Brisbane / QLD: Inner Suburbs
    ['Teneriffe','QLD'],['New Farm','QLD'],['Newstead','QLD'],
    ['Bulimba','QLD'],['Hawthorne','QLD'],['Kangaroo Point','QLD'],
    ['Ascot','QLD'],['Hamilton','QLD'],['Clayfield','QLD'],['Bardon','QLD'],
    ['Paddington','QLD'],['Red Hill','QLD'],['West End','QLD'],
    ['Fortitude Valley','QLD'],['St Lucia','QLD'],['Indooroopilly','QLD'],
    ['Chelmer','QLD'],['Graceville','QLD'],['Sherwood','QLD'],
    // QLD: Gold Coast & Sunshine Coast
    ['Broadbeach','QLD'],['Burleigh Heads','QLD'],['Mermaid Beach','QLD'],
    ['Palm Beach','QLD'],['Noosa Heads','QLD'],['Sunshine Beach','QLD'],
    ['Buderim','QLD'],['Maroochydore','QLD'],
    // Perth / WA
    ['Cottesloe','WA'],['Peppermint Grove','WA'],['Mosman Park','WA'],
    ['Dalkeith','WA'],['Nedlands','WA'],['Claremont','WA'],['Swanbourne','WA'],
    ['City Beach','WA'],['Floreat','WA'],['Subiaco','WA'],['Shenton Park','WA'],
    ['West Perth','WA'],['Mount Lawley','WA'],['South Perth','WA'],
    ['Applecross','WA'],['Scarborough','WA'],['Fremantle','WA'],
    // Adelaide / SA
    ['North Adelaide','SA'],['Walkerville','SA'],['Medindie','SA'],
    ['St Peters','SA'],['Norwood','SA'],['Unley','SA'],['Hyde Park','SA'],
    ['Malvern','SA'],['Toorak Gardens','SA'],['Burnside','SA'],
    ['Glen Osmond','SA'],['Stirling','SA'],['Glenelg','SA'],
    ['Henley Beach','SA'],['Prospect','SA'],
    // Canberra / ACT
    ['Forrest','ACT'],['Griffith','ACT'],['Manuka','ACT'],['Kingston','ACT'],
    ['Yarralumla','ACT'],['Red Hill','ACT'],['Deakin','ACT'],['Braddon','ACT'],
    // Hobart / TAS
    ['Sandy Bay','TAS'],['Battery Point','TAS'],['Hobart','TAS'],
    ['Launceston','TAS'],
    // Darwin / NT
    ['Darwin','NT'],['Fannie Bay','NT'],['Nightcliff','NT'],
  ];

  function getPool() {
    /* only an explicit usd market selects US cities; aud, nzd and any unreadable value fall back to the AU pool */
    var m = null; try { m = localStorage.getItem('archer-market'); } catch (e) {}
    return m === 'usd' ? CITIES_USD : CITIES_AUD;
  }

  var lastIdx = -1, lastState = null;
  function pick() {
    var pool = getPool();
    if (pool.length <= 1) return pool[0];
    var i, tries = 0;
    /* avoid repeating the same suburb OR the same state back-to-back;
       bounded retries so a dominant state can't loop forever */
    do {
      i = Math.floor(Math.random() * pool.length);
      tries++;
    } while ((i === lastIdx || pool[i][1] === lastState) && tries < 12);
    lastIdx = i;
    lastState = pool[i][1];
    return pool[i];
  }

  function rand(min, max) { return Math.floor(Math.random() * (max - min + 1)) + min; }

  /* ── create DOM ── */
  var style = document.createElement('style');
  style.textContent = [
    '#sp-popup{',
      'position:fixed;bottom:24px;left:24px;z-index:9999;',
      'background:#fff;border:1px solid rgba(0,0,0,0.08);',
      'box-shadow:0 4px 24px rgba(0,0,0,0.10);',
      'display:flex;align-items:center;gap:12px;',
      'padding:12px 14px;max-width:300px;',
      'opacity:0;transform:translateY(12px);',
      'transition:opacity 0.35s ease,transform 0.35s ease;',
      'pointer-events:none;',
    '}',
    '#sp-popup.sp-visible{opacity:1;transform:translateY(0);pointer-events:auto;}',
    '#sp-img{width:44px;height:44px;object-fit:cover;flex-shrink:0;background:#f0ede8;}',
    '#sp-body{flex:1;min-width:0;}',
    '#sp-city{font-size:12px;font-weight:600;color:#313437;line-height:1.3;margin:0;}',
    '#sp-sub{font-size:11px;color:#6b6e72;margin:2px 0 0;line-height:1.3;}',
    '#sp-close{',
      'flex-shrink:0;background:none;border:none;cursor:pointer;',
      'font-size:14px;color:#9a9d9f;line-height:1;padding:2px;align-self:flex-start;',
    '}',
    '#sp-close:hover{color:#313437;}',
  ].join('');
  document.head.appendChild(style);

  var el = document.createElement('div');
  el.id = 'sp-popup';
  el.innerHTML =
    '<img id="sp-img" src="' + (window.SP_IMG || '/Assets/NEW%20PDP/1.webp') + '" alt="ARCHER">' +
    '<div id="sp-body">' +
      '<p id="sp-city"></p>' +
      '<p id="sp-sub"></p>' +
    '</div>' +
    '<button id="sp-close" aria-label="Close">&times;</button>';
  document.body.appendChild(el);

  function updatePosition() {
    var bar = document.getElementById('archer-sticky-atc');
    if (bar && bar.classList.contains('is-visible')) {
      el.style.bottom = ((bar.offsetHeight || 80) + 12) + 'px';
    } else {
      el.style.bottom = '24px';
    }
  }
  window.addEventListener('scroll', updatePosition, { passive: true });
  window.addEventListener('resize', updatePosition);
  updatePosition();

  var hideTimer;
  document.getElementById('sp-close').addEventListener('click', function () {
    hide();
    clearTimeout(hideTimer);
  });

  var MAX_PER_SESSION = 2;               /* cap: at most 2 toasts per browser session */
  var SS_KEY = 'archer_sp_shown';
  function shownCount() {
    try { return parseInt(sessionStorage.getItem(SS_KEY), 10) || 0; } catch (e) { return 0; }
  }
  function bumpCount() {
    try { sessionStorage.setItem(SS_KEY, shownCount() + 1); } catch (e) {}
  }
  /* ?popup debug trigger also resets the per-session cap so previews always fire */
  if (window.location.search.indexOf('popup') !== -1) {
    try { sessionStorage.removeItem(SS_KEY); } catch (e) {}
  }

  function show() {
    if (shownCount() >= MAX_PER_SESSION) return;
    var city = pick();
    var secs = rand(4, 55);
    var ago = secs <= 5 ? 'just now' : secs + ' seconds ago';

    document.getElementById('sp-city').textContent =
      'Someone in ' + city[0] + ', ' + city[1];
    document.getElementById('sp-sub').textContent = 'Just purchased ARCHER';

    updatePosition();
    bumpCount();
    el.classList.add('sp-visible');
    hideTimer = setTimeout(hide, 5500);
  }

  function hide() { el.classList.remove('sp-visible'); }

  function ctInterval() {
    var ct = new Date(new Date().toLocaleString('en-US', {timeZone:'America/Chicago'}));
    var hour = ct.getHours() + ct.getMinutes() / 60;
    var frac = Math.max(0, Math.min(1, (hour - 6) / 16));
    var smooth = frac * frac;
    var base = 180000 - smooth * (180000 - 25000);
    var jitter = base * 0.25;
    return Math.round(base - jitter + Math.random() * jitter * 2);
  }

  function schedule(delay) {
    if (shownCount() >= MAX_PER_SESSION) return;
    setTimeout(function () {
      show();
      schedule(ctInterval());
    }, delay);
  }

  if (window.location.search.indexOf('popup') !== -1) {
    setTimeout(show, 800);
  }
  schedule(rand(8000, 20000));

})();
